import React from "react";
import { AppProvider } from "@context/AppContext";

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
